import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './JudgmentResultPage.css';

function JudgmentResultPage() {
    const navigate = useNavigate();
    const location = useLocation();
    
    const handleBackToDepartment = () => {
        navigate('/');
    };

    const handleBackToCourses = () => {
        navigate('/courses');
    };

    const { judgmentResult } = location.state || {};

    // 判定結果の表示用の関数
    const renderRequirementStatus = (value, required, label, isNested = false) => (
        <div className={`requirement-item ${value >= required ? 'requirement-met' : 'requirement-not-met'} ${isNested ? 'nested-item' : ''}`} style={isNested ? {marginLeft: '20px', borderLeft: '3px solid #ddd', paddingLeft: '15px'} : {}}>
            <span className="requirement-label">{label}:</span>
            <span className="requirement-value">{value}単位</span>
            <span className="requirement-required">（必要: {required}単位）</span>
        </div>
    );

    // 学科専門科目群の詳細表示用関数
    const renderSpecializedGroup = () => (
        <div className="specialized-group" style={{border: '2px solid #4CAF50', borderRadius: '8px', padding: '15px', margin: '10px 0', backgroundColor: '#f9f9f9'}}>
            <div className="group-header" style={{marginBottom: '10px'}}>
                <div className={`requirement-item ${judgmentResult.details.major_specialized_total_credits >= judgmentResult.details.required_major_specialized_total ? 'requirement-met' : 'requirement-not-met'}`} style={{backgroundColor: '#e8f5e8', fontWeight: 'bold', border: '1px solid #4CAF50', borderRadius: '4px', padding: '8px'}}>
                    <span className="requirement-label" style={{fontWeight: 'bold'}}>学科専門科目群の合計:</span>
                    <span className="requirement-value" style={{fontWeight: 'bold'}}>{judgmentResult.details.major_specialized_total_credits}単位</span>
                    <span className="requirement-required" style={{fontWeight: 'bold'}}>（必要: {judgmentResult.details.required_major_specialized_total}単位）</span>
                </div>
            </div>
            <div className="group-details" style={{marginLeft: '10px'}}>
                <div style={{color: '#666', fontSize: '14px', marginBottom: '8px'}}>内訳:</div>
                {renderRequirementStatus(judgmentResult.details.major_theory_credits, judgmentResult.details.required_major_theory, '基礎理論系科目', true)}
                {renderRequirementStatus(judgmentResult.details.major_arch_credits, judgmentResult.details.required_major_arch, 'アーキテクチャ系科目', true)}
                {renderRequirementStatus(judgmentResult.details.major_content_credits, judgmentResult.details.required_major_content, 'コンテンツ系科目', true)}
            </div>
        </div>
    );

    // フォールバック用の学科専門科目群表示
    const renderSpecializedGroupFallback = () => {
        const theoryCredits = judgmentResult.details?.major_theory_credits || 0;
        const archCredits = judgmentResult.details?.major_arch_credits || 0;
        const contentCredits = judgmentResult.details?.major_content_credits || 0;
        const totalCredits = theoryCredits + archCredits + contentCredits;
        
        return (
            <div className="specialized-group" style={{border: '2px solid #4CAF50', borderRadius: '8px', padding: '15px', margin: '10px 0', backgroundColor: '#f9f9f9'}}>
                <div className="group-header" style={{marginBottom: '10px'}}>
                    <div className={`requirement-item ${totalCredits >= 42 ? 'requirement-met' : 'requirement-not-met'}`} style={{backgroundColor: '#e8f5e8', fontWeight: 'bold', border: '1px solid #4CAF50', borderRadius: '4px', padding: '8px'}}>
                        <span className="requirement-label" style={{fontWeight: 'bold'}}>学科専門科目群の合計:</span>
                        <span className="requirement-value" style={{fontWeight: 'bold'}}>{totalCredits}単位</span>
                        <span className="requirement-required" style={{fontWeight: 'bold'}}>（必要: 42単位）</span>
                    </div>
                </div>
                <div className="group-details" style={{marginLeft: '10px'}}>
                    <div style={{color: '#666', fontSize: '14px', marginBottom: '8px'}}>内訳:</div>
                    {judgmentResult.details?.major_theory_credits !== undefined && 
                        renderRequirementStatus(judgmentResult.details.major_theory_credits, judgmentResult.details.required_major_theory || 10, '基礎理論系科目', true)}
                    {judgmentResult.details?.major_arch_credits !== undefined && 
                        renderRequirementStatus(judgmentResult.details.major_arch_credits, judgmentResult.details.required_major_arch || 10, 'アーキテクチャ系科目', true)}
                    {judgmentResult.details?.major_content_credits !== undefined && 
                        renderRequirementStatus(judgmentResult.details.major_content_credits, judgmentResult.details.required_major_content || 10, 'コンテンツ系科目', true)}
                </div>
            </div>
        );
    };

    return (
        <div className="judgment-result-container">
            <h1>判定結果</h1>
            {judgmentResult && (
                <div className="result-content">
                    <div className={`final-result ${
                        judgmentResult.status === '卒業可能' ? 'result-success' :
                        judgmentResult.status === '卒業見込み(卒論審査待ち)' ? 'result-pending' : // ★新しい条件とクラスを追加
                        'result-failure'
                    }`}>
                        <h2>{judgmentResult.status}</h2>
                        <p>総取得単位数: {judgmentResult.total_credits}単位（要件：128単位）</p>
                    </div>

                    {judgmentResult.missing_requirements && judgmentResult.missing_requirements.length > 0 && (
                        <div className="missing-requirements">
                            <h3>不足している要件</h3>
                            <ul>
                                {judgmentResult.missing_requirements.map((item, index) => (
                                    <li key={index} className="missing-item">
                                        {Array.isArray(item) ? `${item[0]} (不足: ${item[1]}単位)` : item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="temporary-notice" style={{ marginTop: '10px', padding: '10px', border: '1px solid orange', borderRadius: '5px', backgroundColor: '#fff3e0' }}>
                        <p style={{ margin: 0, color: '#e65100', fontWeight: 'bold' }}>
                            <strong>注意:</strong>
                            DBにデータが存在しない一部の科目があります．履修データに基づき判定されています。
                        </p>
                    </div>

                    <div className="requirements-details">
                        <h3>カテゴリー別取得単位数</h3>
                        <div className="requirements-grid">
                            {judgmentResult.details && (
                                <>
                                    {/* 教養・基盤科目群 */}
                                    <div className="subject-group" style={{border: '1px solid #ddd', borderRadius: '6px', padding: '10px', margin: '8px 0', backgroundColor: '#fafafa'}}>
                                        {renderRequirementStatus(judgmentResult.details.liberal_foundation_credits, judgmentResult.details.required_liberal_foundation, '教養・基盤科目の合計')}
                                        <div style={{color: '#666', fontSize: '14px', marginLeft: '15px', marginTop: '5px'}}>内訳:</div>
                                        {renderRequirementStatus(judgmentResult.details.natural_science_combined_credits, judgmentResult.details.required_natural_science_combined, '自然科学領域', true)}
                                    </div>

                                    {/* 基礎科目群 */}
                                    <div className="subject-group" style={{border: '1px solid #ddd', borderRadius: '6px', padding: '10px', margin: '8px 0', backgroundColor: '#fafafa'}}>
                                        {judgmentResult.details.english_credits !== undefined && judgmentResult.details.required_english !== undefined &&
                                            renderRequirementStatus(judgmentResult.details.english_credits, judgmentResult.details.required_english, '英語科目')}
                                        {renderRequirementStatus(judgmentResult.details.basic_math_total_credits, judgmentResult.details.required_basic_math_total, '理系共通基礎の合計')}
                                        <div style={{color: '#666', fontSize: '14px', marginLeft: '15px', marginTop: '5px'}}>内訳:</div>
                                        {renderRequirementStatus(judgmentResult.details.basic_math_subject_credits, judgmentResult.details.required_basic_math_subject, '数学科目', true)}
                                    </div>

                                    {/* 専門科目群 */}
                                    <div className="subject-group" style={{border: '1px solid #ddd', borderRadius: '6px', padding: '10px', margin: '8px 0', backgroundColor: '#fafafa'}}>
                                        {renderRequirementStatus(judgmentResult.details.major_core_credits, judgmentResult.details.required_major_core, '学科基礎科目')}
                                        {renderRequirementStatus(judgmentResult.details.major_intro_credits, judgmentResult.details.required_major_intro, '領域導入科目')}
                                        
                                        {/* 学科専門科目群 */}
                                        {judgmentResult.details && judgmentResult.details.major_specialized_total_credits !== undefined && judgmentResult.details.required_major_specialized_total !== undefined ? 
                                            renderSpecializedGroup() : 
                                            renderSpecializedGroupFallback()
                                        }
                                        
                                        {renderRequirementStatus(judgmentResult.details.major_experiment_credits, judgmentResult.details.required_major_experiment, '実験科目')}
                                    </div>
                                    {renderRequirementStatus(judgmentResult.details.major_research_credits, judgmentResult.details.required_major_research, '特別研究')}
                                </>
                            )}
                            <div className="requirement-details-separator"></div>
                            <div className="total-credits">
                                <span>総単位数: {judgmentResult.total_credits}単位 (必要: 128単位)</span> {/* 既に適用済み */}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="navigation-buttons">
                <button
                className="back-button"
                onClick={handleBackToDepartment}
                >
                学部学科選択に戻る
                </button>
                <button
                className="back-button"
                onClick={handleBackToCourses}
                >
                授業選択に戻る
                </button>
            </div>
        </div>
    );
}

export default JudgmentResultPage;